import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5996e139"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recent-card__wrap" }
const _hoisted_2 = { class: "recent-card__picture" }
const _hoisted_3 = ["alt"]
const _hoisted_4 = { class: "recent-card__title" }
const _hoisted_5 = { class: "recent-card__title-text" }

import { names } from '@/constants/routes';
import { LabData } from '@/types/LabData';
import LaunchProduct from '@/components/Card/LaunchProduct.vue';
import SourceImage from '@/components/Card/SourceImage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecentCard',
  props: {
    card: {},
    disableStorageUpdate: { type: Boolean }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: _unref(names).laboratory, params: { id: _ctx.card.id } },
    class: "recent-card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("picture", _hoisted_2, [
          _createVNode(SourceImage, { card: _ctx.card }, null, 8, ["card"]),
          _createElementVNode("img", {
            src: "/img/empty/card.png",
            alt: _ctx.card.name,
            class: "recent-card__img",
            loading: "lazy"
          }, null, 8, _hoisted_3)
        ]),
        _createVNode(LaunchProduct, {
          class: "recent-card__play",
          card: _ctx.card,
          disableStorageUpdate: _ctx.disableStorageUpdate
        }, null, 8, ["card", "disableStorageUpdate"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.card.name), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})